
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.112 8.157A4.493 4.493 0 0012 4.5C12 2.019 9.982 0 7.5 0a4.505 4.505 0 00-4.47 4h-.22l-.363-.723a.5.5 0 00-.894.447L1.69 4H1.31l-.362-.723a.5.5 0 00-.894.447L.44 4.5l-.388.776a.5.5 0 00.894.447L1.31 5h.382l-.138.276a.5.5 0 00.894.447L2.81 5h.22a4.497 4.497 0 001.86 3.157L3.54 11.303a.5.5 0 10.919.394l1.305-3.046C6.3 8.876 6.885 9 7.5 9s1.201-.124 1.735-.349l1.306 3.046a.5.5 0 10.919-.394l-1.348-3.146zM7.5 7a2.504 2.504 0 01-2.45-2h1.042c.207.58.757 1 1.408 1C8.327 6 9 5.327 9 4.5S8.327 3 7.5 3c-.65 0-1.2.42-1.408 1H5.051c.232-1.14 1.242-2 2.45-2C8.878 2 10 3.122 10 4.5S8.878 7 7.5 7z"}})])
          )
        }
      }
    